'use client';

import classnames from 'classnames/bind';
import { EAnalytics, ELoginButtonPagePosition } from '@/_constants/analytics';
import { useAnalytics } from '@/_hooks/use-analytics';
import { Button } from '@/_kit/button';
import { EButtonColor, EButtonSize } from '@/_kit/button/_types';
import { redirect } from '@/_utils/redirect';
import { Text } from '@/_kit/text';
import { ETextSize } from '@/_kit/text/_types';
import styles from './index.module.scss';

const cn = classnames.bind(styles);
const BLOCK_NAME = 'LoginButton';

type TProps = {
  text: string;
  color: EButtonColor;
  positionOnPage: ELoginButtonPagePosition.UP | ELoginButtonPagePosition.BOTTOM;
};

export const LoginButton = ({ text, color, positionOnPage }: TProps) => {
  const sendEvent = useAnalytics();

  const handleClick = () => {
    const config = {
      name: EAnalytics.SUPPLIER_LANDING_AUTH_BUTTON_T,
      // eslint-disable-next-line camelcase
      params: { position_button: positionOnPage },
    };

    sendEvent(config);

    redirect();
  };

  return (
    <div className={cn(BLOCK_NAME)}>
      <Button
        size={EButtonSize.MEDIUM}
        backgroundColor={color}
        onClick={handleClick}
        className={cn(`${BLOCK_NAME}__mobile`)}
      >
        <Text size={ETextSize.SMALL} text={text} variant="body" />
      </Button>

      <Button
        size={EButtonSize.LARGE}
        backgroundColor={color}
        onClick={handleClick}
        className={cn(`${BLOCK_NAME}__desktop`)}
      >
        <Text size={ETextSize.MEDIUM} text={text} variant="body" />
      </Button>
    </div>
  );
};
